export const LISTABLE_TYPES_MODELS = {
	'App\\Models\\Building': 'buildings',
	'App\\Models\\Client': 'clients',
	'App\\Models\\Lead': 'leads',
	'App\\Models\\Project': 'projects',
};

export const LISTABLE_TYPES = Object.values(LISTABLE_TYPES_MODELS).reduce((acc, type) => {
	acc[type] = type;
	return acc;
}, {});

export const LISTABLE_TYPES_ARRAY = Object.values(LISTABLE_TYPES_MODELS);

// Shared include list for /listItems queries (ListView, NextListItemTool).
// Fractal ignores includes that don't exist on a given listable type.
export const LIST_ITEM_INCLUDES = [
	'comments',
	'comment',
	// buildings
	'listable.tags',
	'listable.clients',
	'listable.buildings',
	'listable.allBuildingProductStates.product',
	'listable.building.allBuildingProductStates.product',

	// leads
	'listable.client',
	'listable.user',
	'listable.salesmanager.organizations',
	'listable.calendarResource.team',
	'listable.products',
	'listable.organization',
	'listable.leadEvents.user',
	'listable.meta',

	// projects (type/state titles come flat from ProjectTransformer without includes)
	'listable.salesman',
];
